<script>
	import { dateRange, earliestBooking } from "src/utils/misc";
	import CustomSelect from "../../../components/CustomSelect/CustomSelect.svelte";
	import { priorityOptions } from "src/utils/options";
	import {
		assignableTasks,
		assignState,
		totalRecords,
	} from "src/store/store";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown.svelte";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
	import { DropdownItem } from "sveltestrap";
	import { navigate } from "svelte-routing";

	export let backlogTasks = [];
	export let toggleDetails = () => {};
	export let isAssign = false;
	export let checkedTasks = [];
	export let lookups = {};
	export let changeCarStatus = () => {};
	export let changePriority = () => {};
	export let toggleDeleteModal = () => {};
	export let triggerSortBacklog;

	let selectCheckboxes = false;
	let isCarStatusOpen = -1;
	export let sortDir = 1 // 1 for descending, 0 for ascending

	function toggleCarStatus(idx) {
		if (idx === isCarStatusOpen) {
			isCarStatusOpen = -1;
			return;
		}
		isCarStatusOpen = idx;
		return;
	}

	function onChangeCheckbox(e) {
		if (e.target.checked) {
			checkedTasks.push(
				backlogTasks[parseInt(e.target.id)].backlogTaskId
			);
		} else {
			checkedTasks = checkedTasks.filter(
				(task) =>
					task !== backlogTasks[parseInt(e.target.id)].backlogTaskId
			);
		}
		assignableTasks.set(checkedTasks);
	}

	function checkAllBoxes() {
		const checkboxes = document.querySelectorAll(
			'tbody input[type="checkbox"]'
		);
		checkboxes.forEach((checkbox) => (checkbox.checked = true));
		checkedTasks = backlogTasks.map((task) => task.backlogTaskId);
		assignableTasks.set(checkedTasks);
	}

	assignState.subscribe((value) => {
		selectCheckboxes = value;
	});
</script>

<LoaderContainer>
	<table>
		<thead>
			<tr>
				<th>
					{#if selectCheckboxes}
						<input
							type="checkbox"
							on:change={() => {
								checkAllBoxes();
							}}
							style="width: 13%"
							name="vehicleId"
						/>
					{/if}Vehicle No.</th
				>
				<th>
					Car Status 
				</th>
				<th>Task</th>
				<th
					>Priority <i
						role="button"
						on:click={triggerSortBacklog}
						on:keydown={() => {}}
						tabindex="0"
						>{#if sortDir === 1}
							<img
								src="/assets/icon-sort-up-thin.svg"
								alt="icon-sort-up"
							/>
						{:else}
							<img
								src="/assets/icon-sort-down-thin.svg"
								alt="icon-sort-down"
							/>
						{/if}
					</i></th
				>
				<th>Bookings</th>
				<th
					>Region
				</th>
				<th>Estate</th>
				<th>Address</th>
				{#if !isAssign}
					<th>Action</th>
				{/if}
			</tr>
		</thead>
		<tbody>
			{#each backlogTasks as row, rowIndex}
				<tr>
					{#each Object.keys(row) as colKey, colIndex}
						{#if colKey === "Actions"}
							{#if !isAssign || !$assignState}
								<td>
									<TableDropdown>
										<DropdownItem
											on:click={() =>
												toggleDetails(rowIndex)}
										>
											View item
										</DropdownItem>
										<DropdownItem
											on:click={() =>
												toggleDeleteModal(
													row.backlogTaskId
												)}
										>
											Delete item
										</DropdownItem>
									</TableDropdown>
								</td>
							{/if}
						{:else if colKey === "Car Status"}
							<td>
								{#if isAssign}
									<CustomDropdown
										options={lookups.vehicleStatuses}
										value={backlogTasks[rowIndex][colKey]}
										id={backlogTasks[rowIndex].vehicleId}
										isOpen={false}
										chevron={false}
									/>
								{:else}
									<CustomDropdown
										options={lookups.vehicleStatuses}
										toggle={() => toggleCarStatus(rowIndex)}
										isOpen={isCarStatusOpen === rowIndex}
										value={backlogTasks[rowIndex][colKey]}
										handleSelect={changeCarStatus}
										id={backlogTasks[rowIndex].vehicleId}
									/>
								{/if}
							</td>
						{:else if colKey === "Priority"}
							<td>
								{#if isAssign}
									{priorityOptions.find(
										(option) =>
											option.value ===
											backlogTasks[rowIndex][colKey]
									).label}
								{:else}
									<CustomSelect
										value={backlogTasks[rowIndex][colKey]}
										options={priorityOptions}
										classes="search-border table-select"
										defaultOption="Select a priority"
										disableFirstOption
										onChange={(e) => {
											changePriority(
												backlogTasks[rowIndex]
													.backlogTaskId,
												e.target.value
											);
										}}
									/>
								{/if}
							</td>
						{:else if colKey === "Vehicle No."}
							<td>
								{#if selectCheckboxes}
									<input
										style="width: 13%"
										type="checkbox"
										name="taskId"
										id={rowIndex}
										on:change={(e) => onChangeCheckbox(e)}
									/>
								{/if}
								<span
									on:click={() =>
										navigate(
											`/car-management/details/${row["vehicleId"]}`
										)}
									on:keydown={() => {}}
									class="link link-text"
								>
									{row[colKey]}
								</span>
							</td>
						{:else if colKey === "Bookings"}
							<td class="booking-container">
								<span
									class="booking-text"
									style={isAssign && row[colKey]?.length
										? "color: red"
										: ""}
								>
									{row[colKey]?.length
										? row[colKey]?.length
										: isAssign
										? 0
										: "-"}
									{#if isAssign && row[colKey]?.length}
										<img
											src="/assets/icon-danger.svg"
											alt="icon-danger"
										/>
									{/if}
									{#if row[colKey] && row[colKey].length > 0}
										<div class="booking-tooltip">
											<span>
												<b>
													Bookings {`(${earliestBooking(
														row[colKey][0].start
													)})`}
												</b>
											</span>
											{#each row[colKey] as booking}
												<li>
													{dateRange(
														booking.start,
														booking.end
													)}
												</li>
											{/each}
										</div>
									{/if}
								</span>
							</td>
						{:else if colKey == "Estate"}
							<td>{row[colKey]}</td>
						{:else if colKey !== "backlogTaskId" && colKey !== "vehicleId"}
							<td>{row[colKey]}</td>
						{/if}
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
	{#if !isAssign && backlogTasks.length > 0}
		<Pagination totalRecord={$totalRecords} />
	{/if}
</LoaderContainer>

<style>
	table {
		width: 100%;
		border-collapse: collapse;
		max-height: 300px;
		overflow-y: auto;
		border: 1px solid #e8e8e8;
		table-layout: auto;
	}

	tr {
		border-bottom: 1px solid #e8e8e8;
	}

	tr:hover {
		background-color: #ececec;
	}

	input,
	select {
		width: 100%;
		padding: 8px;
		font-size: 14px;
		border: 1px solid #ccc;
		border-radius: 4px;
		background: #fff;
		outline: none;
	}

	input:focus,
	select:focus {
		border-color: #007bff;
		box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
	}

	button.delete {
		background: none;
		border: none;
		color: #dc3545;
		cursor: pointer;
		font-size: 18px;
	}

	button.delete:hover {
		color: #a71d2a;
	}

	button.add {
		margin: 10px 0;
		padding: 10px 15px;
		background-color: #007bff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}

	button.add:hover {
		background-color: #0056b3;
	}

	td, th {
		padding: 12px 16px;
		border-right: 1px solid #e8e8e8;
		align-self: stretch;
	}

	input {
		border-color: transparent !important;
	}

	select {
		border-color: transparent !important;
	}

	select:focus {
		box-shadow: none !important;
	}

	input:focus {
		box-shadow: none !important;
	}

	:global(.table-select) {
		background-color: inherit;
	}

	:global(.form-select.getgo.select.search-border) {
		border-color: transparent !important;
	}

	:global(.form-control.getgo.input.search-border) {
		border-color: transparent !important;
	}

	.booking-container {
		position: relative;
	}

	.booking-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.booking-tooltip {
		visibility: hidden;
		width: fit-content;
		background-color: black;
		color: #fff;
		text-align: left;
		border-radius: 6px;
		padding: 5px 15px;
		position: absolute;
		z-index: 1;
		top: 50%; /* Position the tooltip above the text */
		left: 50%;
		margin-left: -60px;
		opacity: 0;
		transition: opacity 0.3s;
	}

	.booking-container:hover .booking-tooltip {
		visibility: visible;
		opacity: 1;
	}
</style>
